import React, { useContext } from 'react';
import styled, { css, keyframes, createGlobalStyle } from 'styled-components';
import CartContext from '../contexts/CartContext';

import Iframe from './Iframe';
import ToggleIcon from './elements/ToggleIcon';
import AnimatedCheckmark from './elements/AnimatedCheckmark';

import { ReactComponent as Close } from '../../common/icons/down_ui.svg';
import { ReactComponent as Gift } from '../../common/icons/gift.svg';

const launcherAppear = keyframes`
    0% {
      opacity: 0;
      -webkit-transform: scale(.5, .5);
      transform: scale(.5, .5)
    }

    to {
      opacity: 1;
      -webkit-transform: scale(1, 1);
      transform: scale(1, 1)
    }
`;

const LauncherFrame = styled(Iframe)`
  z-index: 2147483000 !important;
  position: fixed !important;
  bottom: 100px;
  ${(props) => (props.theme.alignLeft ? 'left' : 'right')}: 8px;
  width: 80px !important;
  height: 80px !important;
  animation: ${launcherAppear} 250ms ease !important;

  @media only screen and (max-device-width: 667px) {
    bottom: 30px;
  }
`;

const LauncherCheckmark = styled(AnimatedCheckmark)`
  position: absolute;
  top: 8px;
  right: 7px;
  z-index: 1;
  width: 18px;
  height: 18px;
`;

const LauncherCircle = styled.div.attrs(() => ({
  className: 'GiftBox-LauncherCircle',
}))`
  position: relative;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.1);
  width: 60px;
  height: 60px;
  border-radius: 100%;
  background: #fff;
  margin: 5px;
`;

const LauncherNotification = styled.div.attrs(() => ({
  className: 'GiftBox-LauncherNotification',
}))`
  position: absolute;
  top: 8px;
  right: 7px;
  z-index: 1;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #ff0000;
  display: flex;
  font-size: 11px;
  line-height: 11px;
  justify-content: center;
  color: #fff;

  span {
    transform: translateY(4px);
  }
`;

const Launcher = styled.div.attrs(() => ({
  className: 'GiftBox-Launcher',
}))`
  position: absolute;
  top: 0;
  left: 0;
  width: 60px;
  height: 60px;
  border-radius: 25%;
  cursor: pointer;
  transform-origin: center;
  backface-visibility: hidden;
  overflow: hidden;
`;

const CloseIcon = styled(ToggleIcon)`
  opacity: 0;
  color: #111;
  transform: rotate(-30deg);

  ${(props) =>
    props.open &&
    css`
      opacity: 1;
      transform: rotate(0deg);
    `};
`;

const OpenIcon = styled(ToggleIcon)`
  svg {
    height: 36px;
  }
  opacity: 1;
  transform: rotate(0deg) scale(1);
  img {
    border-radius: 100%;
    max-height: 50px;
    max-width: 50px;
  }

  ${(props) =>
    props.open &&
    css`
      opacity: 0;
      transform: rotate(30deg) scale(0);
    `};
`;

export default ({
  open,
  toggle,
  remainingOffers,
  theme,
  tracker,
  offers,
  settings,
  hasAddedOffer,
}) => {
  const { cart } = useContext(CartContext);
  const CustomCss = createGlobalStyle`${settings.custom_css}`;

  return (
    <LauncherFrame
      theme={theme}
      data-cy="launcher"
      className={`GiftBox-LauncherFrame GiftBox-LauncherFrame-${
        open ? 'Open' : 'Closed'
      } ${hasAddedOffer ? 'has-gift' : ''}`}
    >
      <>
        {remainingOffers ? (
          <LauncherNotification data-cy="notification">
            <span>{remainingOffers}</span>
          </LauncherNotification>
        ) : (
          <LauncherCheckmark />
        )}
        <LauncherCircle>
          <Launcher
            onClick={() => {
              if (open) {
                tracker.trackLauncherClickClose(cart);
              } else {
                tracker.trackLauncherClickOpen(offers, cart);
              }
              toggle();
            }}
          >
            <OpenIcon open={open}>
              {window.GIFTBOX_CUSTOM_LAUNCHER_ICON ? (
                <img
                  src={window.GIFTBOX_CUSTOM_LAUNCHER_ICON}
                  alt="custom launcher icon"
                />
              ) : (
                <Gift />
              )}
            </OpenIcon>
            <CloseIcon open={open}>
              <Close />
            </CloseIcon>
          </Launcher>
        </LauncherCircle>
        <CustomCss />
      </>
    </LauncherFrame>
  );
};
